import type { TRuleWithTheme } from '@ackee/fela';

export const delimiter: TRuleWithTheme = ({ theme }) => ({
    fontSize: '1.25rem',
    lineHeight: '1.5rem',

    marginRight: '0.6em',
    marginLeft: '0.6em',
});
